import { Grade } from "./grade"
import { Header as GradeHeader } from "./grade/Layout"
import { Surfacado } from "./surfacado"
import { Header as SurfacadoHeader } from "./surfacado/Layout"
import { Parapar } from "./parapar"

export const Item = ({ type, user, item }) => {
  const baseProps = {
    item,
    user,
  }

  const layouts = {
    parapar: <Parapar {...baseProps} />,
    grade: <Grade {...baseProps} />,
    surfacado: <Surfacado {...baseProps} />,
  }

  return <>{layouts[type]}</>
}

export const chooseHeader = (type) => {
  const headers = {
    grade: <GradeHeader />,
    surfacado: <SurfacadoHeader />,
  }

  return headers[type]
}
